import Lottie from 'lottie-react';
import React, { useEffect, useState } from 'react';
import ReportHeaderFile from '../../components/HeaderFileReport/ReportHeaderFile';
import FilterWithDate from '../../Common/FilterWithDate/FilterWithDate';
import TabHeadingComp from '../../Common/TabHeading/TabHeading';
import styled from 'styled-components';
import OverviewsTab from './Reports/OverviewsTab';
import { useDispatch, useSelector } from 'react-redux';
import { getEnterpriseReportSlice } from '../../store/redux/slices/enterpriseSlice';
import Loader from '../../assests/animation/Loader2.json';
import SentimentsTab from './Reports/SentimentsTab';
import ClusterAnalysisTab from '../ActiveTopic/ClusterAnalysisTab/ClusterAnalysisTab';
import InsightsTab from './Reports/InsightsTab';
import ReviewsTab from './Reports/ReportsTab';
import { formatDateFilter } from '../../utils';
import FilterPopup from '../../Common/FilterPopup/FilterPopup';


const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  font-family: Open Sans;
`;

const LoaderDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80vh;
    & > svg {
    
    width: 300px;
    height: 300px;
    }
}
`;
const ActiveEnterprise = ({ job_id }) => {
    console.log(job_id, "job_id");
    const [orgView, setOrgView] = useState('horizontal');
    const [view, setView] = useState('horizontal');
    // resetFlagFunc
    const [filterOption, setFilterOption] = useState('Bar Graph');
    const [selectedOption, setSelectedOption] = useState('Bar Graph');
    const [filterFlag, setFilterFlag] = useState(false);
    const [activeTab, setActiveTab] = useState('overViewTab');
    const [orgFilterOption, setOrgFilterOption] = useState('Bar Graph');
    const [loader, setLoader] = useState(false);
    const { enterprise_report, resetFlag } = useSelector((state) => state?.enterprise);
    const { personalDetailsData } =
        useSelector((state) => state.tenantSetting) || {};
    const [openDropdown, setOpenDropdown] = useState(null);
    const dispatch = useDispatch();

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };
    let fetchedData = {};

    useEffect(() => {
        if (job_id) {
            setLoader(true)
            dispatch(getEnterpriseReportSlice({ job_id })).then((res) => {
                // fetchedData = res?.payload?.data?.data;
                setLoader(false)
            });
        }

    }, [job_id])

    const overView_tab = enterprise_report?.data?.overview_tab || {};
    const sentiments_tab = enterprise_report?.data?.sentiments_tab || {};
    const reach_tab = enterprise_report?.data?.reach_tab || {};
    const insights_tab = enterprise_report?.data?.insights_tab || {};
    const clusterAnalysis_tab = enterprise_report?.data?.cluster_analysis_tab || {};


    let startDate = formatDateFilter(enterprise_report?.start_date)
    let endDate = formatDateFilter(enterprise_report?.end_date)


    const formatValue =
        personalDetailsData?.app_preference?.date_format === 'dd/mm/yyyy'
            ? 'dd/MM/yyyy'
            : personalDetailsData?.app_preference?.date_format === 'mm/dd/yyyy'
                ? 'MM/dd/yyyy'
                : personalDetailsData?.app_preference?.date_format === 'yyyy/mm/dd'
                    ? 'yyyy/MM/dd'
                    : 'dd/MM/yyyy';
    const renderTabContent = () => {
        switch (activeTab) {
            case 'overViewTab':
                return (
                    <OverviewsTab
                        overview_tab={overView_tab}
                        startDate={startDate}
                        initialStartDate={startDate}
                        endDate={endDate}
                        initialEndDate={endDate}
                        resetFlag={resetFlag}
                        view={orgView}
                        formatValue={formatValue}
                        filterOption={orgFilterOption}
                    />
                );
            case 'sentimentsTab':
                return (
                    <SentimentsTab
                        sentiments_tab={sentiments_tab}
                        startDate={startDate}
                        initialStartDate={startDate}
                        endDate={endDate}
                        initialEndDate={endDate}
                        resetFlag={resetFlag}
                        view={orgView}
                        formatValue={formatValue}
                        filterOption={orgFilterOption}
                        insights_data={insights_tab}
                    />
                );
            case 'insightTab':
                return (
                    <InsightsTab
                        insights_data={insights_tab}
                        startDate={startDate}
                        initialStartDate={startDate}
                        endDate={endDate}
                        initialEndDate={endDate}
                        resetFlag={resetFlag}
                        view={orgView}
                        formatValue={formatValue}
                        filterOption={orgFilterOption}
                    />
                );
            case 'clusterAnalysis':
                return (
                    <ClusterAnalysisTab
                        cluster_analysis={clusterAnalysis_tab}
                        startDate={startDate}
                        initialStartDate={startDate}
                        endDate={endDate}
                        initialEndDate={endDate}

                        resetFlag={resetFlag}
                        view={orgView}
                        formatValue={formatValue}
                        filterOption={orgFilterOption}
                        job_id={job_id}
                        handleTabClick={(data) => {
                            handleTabClick(data);
                        }}
                    />
                );
            //   case 'customAnalysis':
            //     return (
            //       <CustomAnalysisTab
            //         job_id={job_id}
            //         handleTabClick={(data) => {
            //           handleTabClick(data);
            //         }}
            //         preview_uuid={topicPreviewData?.preview_uuid}
            //         onUpdateSearchQuery={updateSearchQuery}
            //         channel={topicPreviewData?.channel}
            //       />
            //     );
            case 'reviewsTab':
                return (
                    <ReviewsTab
                        job_id={job_id}

                        filterOption={orgFilterOption}
                        startDate={startDate}
                        initialStartDate={startDate}
                        endDate={endDate}
                        initialEndDate={endDate}
                    />
                );
            default:
                return null;
        }
    };
    const handleFilter = () => {
        setFilterFlag(true)
    }
    const handleClosePopup = () => {
        setFilterFlag(false)

    }

    const handleFilterChange = (selectedOption) => {
        console.log(selectedOption, "selectedOption");

        setFilterOption(selectedOption);
        if (selectedOption === 'Bar Graph') {
            setView('horizontal');
        } else {
            setView('');
        }
    };

    const handleCancel = () => {
        setView(orgView);
        setFilterFlag(false);
        setFilterOption(orgFilterOption);
        setSelectedOption(orgFilterOption);
    };

    const handleApply = () => {
        setFilterFlag(!filterFlag);
        setOrgFilterOption(filterOption);
        setOrgView(view);
    };
    const handleClear = () => {
        setOrgFilterOption('Bar Graph');
        setOrgView('horizontal');
        setView('horizontal');
    };
    return (

        <Wrapper>
            {
                filterFlag &&
                <FilterPopup
                    handleClosePopup={handleClosePopup}
                    setSelectedOption={setSelectedOption}
                    selectedOption={selectedOption}
                    filterOption={filterOption}
                    handleFilterChange={handleFilterChange}
                    openDropdown={openDropdown}
                    setOpenDropdown={setOpenDropdown}
                    view={view}
                    setView={setView}
                    handleCancel={handleCancel}
                    handleApply={handleApply}
                    handleClear={handleClear}
                />
            }
            {
                loader ?
                    <LoaderDiv >
                        <Lottie
                            data-testid='loader'
                            animationData={Loader}
                            loop={true}
                            width='100px'
                            height='100px'
                        />
                    </LoaderDiv> :
                    <>
                        <ReportHeaderFile
                            job_id={job_id}
                            topicPreviewData={enterprise_report}
                        />

                        <FilterWithDate
                            channel={'enterprise'}
                            job_id={job_id}
                            startDate={startDate}
                            initialStartDate={startDate}
                            endDate={endDate}
                            initialEndDate={endDate}
                            handleFilter={handleFilter}
                        />
                        <TabHeadingComp activeTab={activeTab} handleTabClick={handleTabClick} channel={'enterprise'} />
                        <div style={{ width: '98%',overflow:'auto' }}>{renderTabContent()}</div>
                    </>

            }
        </Wrapper>
    );
};

export default ActiveEnterprise;